"use client";
import { usePathname } from 'next/navigation'

import styles from "./LayoutWrapper.module.css";

export const LayoutWrapper = ({
  className = "",
  children,
  styling,
  isHeader = false
}: {
  className?: string;
  children: React.ReactNode;
  styling?: {
    display: React.CSSProperties["display"];
    justifyContent: React.CSSProperties["justifyContent"];
  };
  isHeader?: boolean;
}) => {
  const pathname = usePathname()
  const fullWidthJourney = pathname?.includes("offline-journey") || pathname?.includes("cc-journey") || pathname?.includes("pl-journey") || pathname?.includes("sl-journey")  

  return (
    <div
      data-testid="layout-wrapper"
      className={`${styles.containerWrapper} ${fullWidthJourney ? styles.fullWidth : ''} ${className}`}
      style={{
        display: styling?.display,
        padding: fullWidthJourney && !isHeader ? "0" : "16px 16px 16px 16px",
        justifyContent: styling?.display?.includes("flex") && styling?.justifyContent ? styling.justifyContent : undefined
      }}
    >
      {children}
    </div>
  );
};
